import createPermissionsForUser from './access/createPermissionsForUser'
import deletePermissionsForUser from './access/deletePermissionsForUser'
import getAllUserPermissions from './access/getAllUserPermissions'
import getUserPermissions from './access/getUserPermissions'
import updatePermissionsForUser from './access/updatePermissionsForUser'
import acceptAccount from './accounts/acceptAccount'
import rejectAccount from './accounts/rejectAccount'
import editAccount from './accounts/editAccount'
import createNewAccount from './accounts/createNewAccount'
import getAccounts from './accounts/getAccounts'
import getSingleAccount from './accounts/getSingleAccount'
import submitStgFollowUp from './accounts/submitStgFollowUp'
import stgApproveAccount from './accounts/stgApproveAccount'
import stgRejectAccount from './accounts/stgRejectAccount'

import acceptgcpProject from './gcpProjects/acceptgcpProject'
import rejectgcpProject from './gcpProjects/rejectgcpProject'
import editgcpProject from './gcpProjects/editgcpProject'
import createNewgcpProject from './gcpProjects/createNewgcpProject'
import getgcpProjects from './gcpProjects/getgcpProject'
import getSinglegcpProject from './gcpProjects/getSinglegcpProject'
import updateGcpProjectDetails from './gcpProjects/updateDetails'

import createNewCert from './gcpCerts/createNewCert'
import getSingleCert from './gcpCerts/getSingleCert'
import getCerts from './gcpCerts/getCert'
import getAllCerts from './gcpCerts/getAllCerts'
import approveCert from './gcpCerts/approveCert'
import rejectCert from './gcpCerts/rejectCert'
import reopenCert from './gcpCerts/reopenCert'
import updateCertApprovers from './gcpCerts/updateCert'
import updateCertDetails from './gcpCerts/updateCertDetails'

import getMicroservices from './microservices/getMicroservices'
import createNewMicroservice from './microservices/createNewMicroservice'
import editMicroservice from './microservices/editMicroservice'
import rejectMicroservice from './microservices/rejectMicroservice'
import acceptMicroservice from './microservices/acceptMicroservice'
import getSingleMicroservice from './microservices/getSingleMicroservice'

import acceptProject from './projects/acceptProject'
import createNewProject from './projects/createNewProject'
import editProject from './projects/editProject'
import getProjects from './projects/getProjects'
import getSingleProject from './projects/getSingleProject'
import rejectProject from './projects/rejectProject'

import createTags from './tags/createTags'
import getTagsById from './tags/getTagsById'
import updateMultiStepTagsById from './tags/updateMultiStepTagsById'
import approveTagsById from './tags/approveTagsById'
import updateTagsById from './tags/updateTagsById'
import getTagsByAccountId from './tags/getTagsByAccountId'

import getPlatforms from './platforms/getPlatforms'
import createNewPlatform from './platforms/createNewPlatform'
import editPlatform from './platforms/editPlatform'
import rejectPlatform from './platforms/rejectPlatform'
import acceptPlatform from './platforms/acceptPlatform'
import getSinglePlatform from './platforms/getSinglePlatform'

import getApplications from './applications/getApplication'
import getSingleApplication from './applications/getSingleApplication'
import rejectApplication from './applications/rejectApplication'
import editApplication from './applications/editApplication'
import createNewApplication from './applications/createNewApplication'
import acceptApplication from './applications/acceptApplication'
import getTagsByGCPProjectId from './tags/getTagsByGCPProjectId'
import getSingleRhocpTenant from './rhocpTenants/getSingleRhocpTenant'
import createNewRhocpTenant from './rhocpTenants/createNewRhocpTenant'
import acceptRhocpTenant from './rhocpTenants/acceptRhocpTenant'
import rejectRhocpTenant from './rhocpTenants/rejectRhocpTenant'
import getRhocpTenants from './rhocpTenants/getRhocpTenants'

import createNewResource from './projects/resources/createNewResource'
import getProjectResources from './projects/resources/getProjectResources'
import getSingleProjectResource from './projects/resources/getSingleProjectResource'
import approveResource from './projects/resources/approveResource'
import rejectResource from './projects/resources/rejectResource'
import getAllProjectResources from './projects/resources/getAllProjectResources'
import updateApprovers from './projects/resources/updateApprovers'

import getClusters from './clusters/getClusters'
import getSingleCluster from './clusters/getSingleCluster'
import createNewCluster from './clusters/createNewCluster'
import acceptCluster from './clusters/acceptCluster'
import rejectCluster from './clusters/rejectCluster'

import getApis from './apis/getApis'
import createNewApi from './apis/createNewApi'
import editApi from './apis/editApi'
import rejectApi from './apis/rejectApi'
import acceptApi from './apis/acceptApi'
import getSingleApi from './apis/getSingleApi'
import getAllAdGroups from './active-directory/getAllAdGroups'
import addAdGroupMember from './active-directory/addAdGroupMember'

const api = {
	projects: {
		getProjects,
		getSingleProject,
		createNewProject,
		rejectProject,
		acceptProject,
		editProject,
		resources: {
			createNewResource,
			getProjectResources,
			getSingleProjectResource,
			getAllProjectResources,
			approveResource,
			rejectResource,
			updateApprovers
		}
	},
	activeDirectory: {
		addAdGroupMember,
		getAllAdGroups
	},
	accessManagement: {
		getUserPermissions,
		getAllUserPermissions,
		createPermissionsForUser,
		updatePermissionsForUser,
		deletePermissionsForUser
	},
	accounts: {
		getAccounts,
		getSingleAccount,
		createNewAccount,
		submitStgFollowUp,
		stgApproveAccount,
		stgRejectAccount,
		acceptAccount,
		rejectAccount,
		editAccount
	},
	tags: {
		getTagsById,
		createTags,
		updateMultiStepTagsById,
		approveTagsById,
		updateTagsById,
		getTagsByAccountId,
		getTagsByGCPProjectId
	},
	platforms: {
		getPlatforms,
		getSinglePlatform,
		createNewPlatform,
		editPlatform,
		acceptPlatform,
		rejectPlatform
	},
	applications: {
		getApplications,
		getSingleApplication,
		createNewApplication,
		editApplication,
		acceptApplication,
		rejectApplication
	},
	microservices: {
		getMicroservices,
		createNewMicroservice,
		getSingleMicroservice,
		acceptMicroservice,
		rejectMicroservice,
		editMicroservice
	},
	gcpProjects: {
		getgcpProjects,
		getSinglegcpProject,
		createNewgcpProject,
		acceptgcpProject,
		rejectgcpProject,
		editgcpProject,
		updateDetails: updateGcpProjectDetails
	},
	gcpCerts: {
		createNewCert,
		getCerts,
		getSingleCert,
		getAllCerts,
		approveCert,
		rejectCert,
		reopenCert,
		updateCertApprovers,
		updateCertDetails
	},
	rhocpTenants: {
		getSingleRhocpTenant,
		getRhocpTenants,
		createNewRhocpTenant,
		acceptRhocpTenant,
		rejectRhocpTenant
	},
	apis: {
		getApis,
		createNewApi,
		getSingleApi,
		acceptApi,
		rejectApi,
		editApi
	},
	clusters: {
		getClusters,
		getSingleCluster,
		createNewCluster,
		acceptCluster,
		rejectCluster
	}
}

export default api
